import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import productImg from "../../img/product_img_landing/tpm_02.jpg";

const TPM_02 = () => {
  return (
    <div>
      <Navbar />
      <div className="container mt-5 pt-5">
        <div className="row mt-4">
          <div className="col-lg-6 mb-4">
            <img
              src={productImg}
              alt="TPM-02 Tongue Pressure Measurement Device"
              className="img-fluid"
              style={{ borderRadius: "10px" }}
            />
          </div>
          <div className="col-lg-6">
            <p className="text-muted mb-1">JMS Co., Ltd., Japan</p>
            <h2 className="fw-bold">Tongue Pressure Measurement Device</h2>
            <h5 className="text-danger mb-3">Model: TPM-02</h5>
            <div className="dash mb-3"></div>
            <p className="lh-lg">
              The JMS Tongue Pressure Measurement Device (TPM-02) is a medical device
              designed to objectively measure maximum tongue pressure — an important indicator
              of oral motor function and swallowing ability.
            </p>
            <p className="lh-lg">
              The device supports the assessment of feeding and swallowing disorders, helping
              healthcare professionals identify patients who may be at risk of dysphagia
              (swallowing difficulties), malnutrition, and related complications.
            </p>
            <ul className="mt-3 lh-lg">
              <li><strong>Generic Name:</strong> Digital Tongue Pressure Meter</li>
              <li><strong>Risk Class:</strong> Class B</li>
              <li><strong>Manufacturer:</strong> JMS Co., Ltd., Japan</li>
              <li><strong>Importer:</strong> Aura Medical Limited</li>
            </ul>
          </div>
        </div>

        {/* Main Features */}
        <div className="mt-5">
          <h3 className="fw-bold mb-3">Main Features</h3>
          <div className="dash1 mb-4"></div>
          <ul className="lh-lg" style={{ fontSize: "17px" }}>
            <li>Automatic internal pressure adjustment at 19.6 kPa</li>
            <li>Measurement range: -9.9 to 99.9 kPa</li>
            <li>Measurement accuracy: ±1 kPa</li>
            <li>Digital numeric display with graphical level indication</li>
            <li>Battery-operated portable design</li>
            <li>Dedicated software available for displaying measurement values and waveform data</li>
          </ul>
        </div>

        {/* Specifications */}
        <div className="mt-5 mb-5">
          <h3 className="fw-bold mb-3">Specifications</h3>
          <div className="dash1 mb-4"></div>
          <table className="table table-bordered border-table">
            <tbody>
              <tr>
                <td><strong>Device Name</strong></td>
                <td>JMS Tongue Pressure Measurement Device</td>
              </tr>
              <tr>
                <td><strong>Model Type</strong></td>
                <td>TPM-02</td>
              </tr>
              <tr>
                <td><strong>Power Supplies</strong></td>
                <td>AA alkaline battery × 2 or AA nickel-metal-hydride rechargeable battery × 2</td>
              </tr>
              <tr>
                <td><strong>Voltage</strong></td>
                <td>DC 3V (AA alkaline) / DC 2.4V (AA rechargeable)</td>
              </tr>
              <tr>
                <td><strong>Measurable Number</strong></td>
                <td>Approx. 2,500 times</td>
              </tr>
              <tr>
                <td><strong>Durability</strong></td>
                <td>5 years (About 45,000 pressurization pump operations)</td>
              </tr>
              <tr>
                <td><strong>Dimensions</strong></td>
                <td>74 (W) × 120 (L) × 27.5 (H) mm</td>
              </tr>
              <tr>
                <td><strong>Internal Pressure Adjustment</strong></td>
                <td>19.6 kPa, within 20 seconds, accuracy ±1.0 kPa</td>
              </tr>
              <tr>
                <td><strong>Measurement Range</strong></td>
                <td>-9.9 to 99.9 kPa</td>
              </tr>
              <tr>
                <td><strong>Measurement Accuracy</strong></td>
                <td>±1 kPa</td>
              </tr>
              <tr>
                <td><strong>Display Format</strong></td>
                <td>Digital numbers and bar graphs (Level sign indication)</td>
              </tr>
              <tr>
                <td><strong>Electric Shock Protection</strong></td>
                <td>Internal power supply BF type applied parts</td>
              </tr>
              <tr>
                <td><strong>Drip-proof Properties</strong></td>
                <td>IPX0</td>
              </tr>
              <tr>
                <td><strong>External Output</strong></td>
                <td>USB (data transmission only)</td>
              </tr>
              <tr>
                <td><strong>Option</strong></td>
                <td>Software for Tongue Pressure Measurement Data</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TPM_02;
